import { SelfServiceAPI } from 'types';

export const showPaidByQantasTravelPass = (booking: SelfServiceAPI.Booking): boolean =>
  !!booking.transactions.find((item) => item.chargeBreakdown.qantasGroupCreditVoucher.paymentMethod);
